import ResponsiveCDNImage from "../../../../components/common/image/responsive-cdn-image";
import heroGray from "../../../../assets/images/hero_gray.png";
import { HiOutlinePhoto } from "react-icons/hi2";

interface ReviewBestBlockProps {
  reviewImages?: Array<{ img?: string | null } | null> | null;
  content?: string | null;
}

export function ReviewBestBlock({
  reviewImages,
  content,
}: ReviewBestBlockProps) {
  const hasImages = reviewImages && reviewImages.length > 0;
  const hasMultipleImages = reviewImages && reviewImages.length > 1;

  return (
    <div className="flex flex-col gap-2 pt-4 ">
      <p className="text-2xl font-bold pl-4">👑 Best Review</p>
      <div className="flex flex-col p-3 px-4 rounded-lg">
        <div className="h-full w-[60%]">
          {hasImages ? (
            <div className="relative w-full h-full">
              <ResponsiveCDNImage
                src={reviewImages?.[0]?.img ?? undefined}
                alt="베스트 리뷰 이미지"
                className="w-full h-full aspect-square object-cover rounded-lg"
                sizeRatio={1}
              />
            </div>
          ) : (
            <div className="w-full h-full bg-gray-50 flex items-center justify-center rounded-lg aspect-square">
              <ResponsiveCDNImage
                src={heroGray}
                alt="베스트 리뷰 이미지"
                className="w-full h-full aspect-square object-contain rounded-lg"
                sizeRatio={1}
              />
            </div>
          )}
        </div>
        <div className="w-[100%] p-4 mt-4 bg-gray-50 rounded-lg">
          {hasMultipleImages && (
            <div className="inline-flex items-center gap-1 mb-2 bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-xs font-medium">
              <HiOutlinePhoto className="w-3 h-3" />
              <span>+{reviewImages!.length - 1}</span>
            </div>
          )}
          <span className="text-gray-600 font-bold text-start">{content}</span>
        </div>
      </div>
    </div>
  );
}
